<template>
	<div>
		<el-row>
			<el-col>
				<div class="csos-logo">
					<img class="logo" src="../assets/logo5.png" />
				</div>
				<el-menu :default-active="activeIndex" :default-openeds="openedsIndex" class="el-menu-vertical-demo default-active">
					<el-submenu index="1" class="default-active">
						<template slot="title">
							<span slot="title"><translate>Operation</translate></span>
						</template>
						<el-menu-item-group>
							<router-link to="/operation/dashboard" v-show="[1, 2, 3, 4].includes(currentAccount.is_admin)">
								<el-menu-item index="1-1" data-router='{"/operation/dashboard": "1-1"}'>
									<i class="material-icons">apps</i>
									<translate>Dashboard</translate>
								</el-menu-item>
							</router-link>
							<router-link to="/operation/workgroup" v-show="[0, 1].includes(currentAccount.is_admin)">
								<el-menu-item index="1-2" data-router='{"/operation/workgroup": "1-2"}'>
									<i class="material-icons">tune</i>
									<translate>WorkGroup</translate>
								</el-menu-item>
							</router-link>
							<router-link to="/operation/log" v-show="[0, 1, 2, 4].includes(currentAccount.is_admin)">
								<el-menu-item index="1-3" data-router='{"/operation/log": "1-3"}'>
									<i class="material-icons">event_note</i>
									<translate>Log</translate>
								</el-menu-item>
							</router-link>
							<router-link :to="{ name: 'operation.review', query: { type: 'sql' } }" v-show="[0, 1].includes(currentAccount.is_admin)">
								<el-menu-item index="1-4" data-router='{"/operation/review":"1-4"}'>
									<i class="material-icons">account_balance</i>
									<translate>Application</translate>
								</el-menu-item>
							</router-link>
							<!--<router-link to="/operation/document">-->
							<!--<el-menu-item index="1-5" data-router='{"/operation/document": "1-5"}'>-->
							<!--<i class="material-icons">description</i>-->
							<!--<translate>Document</translate>-->
							<!--</el-menu-item>-->
							<!--</router-link>-->
						</el-menu-item-group>
					</el-submenu>
					<el-submenu index="2" v-show="[1, 3].includes(currentAccount.is_admin)">
						<template slot="title">
							<translate>Configuration</translate>
						</template>
						<el-menu-item-group>
							<router-link to="/settings/workgroup">
								<el-menu-item index="2-1" data-router='{"/settings/workgroup": "2-1"}'>
									<i class="material-icons">dvr</i>
									<translate>WorkGroup Manage</translate>
								</el-menu-item>
							</router-link>
							<router-link to="/settings/cluster">
								<el-menu-item index="2-2" data-router='{"/settings/cluster": "2-2"}'>
									<i class="material-icons">view_list</i>
									<translate>Cluster Manage</translate>
									<i class="el-icon-warning" v-if="isUpdateAgent" style="color: #fda541; font-size: 14px; top: 2px"></i>
								</el-menu-item>
							</router-link>
							<router-link v-show="[1].includes(currentAccount.is_admin)" :to="{ name: 'team', query: { type: 'members' } }">
								<el-menu-item index="2-3" data-router='{"/settings/team": "2-3"}'>
									<i class="material-icons">group</i>
									<translate>Team Manage</translate>
								</el-menu-item>
							</router-link>
						</el-menu-item-group>
					</el-submenu>
					<el-submenu index="3">
						<template slot="title">
							<translate>System</translate>
						</template>
						<el-menu-item-group>
							<router-link :to="{ name: 'statistics', query: { type: 'overview' } }">
								<el-menu-item index="3-1" data-router='{"/system/statistics": "3-1"}' v-show="[1, 2, 4].includes(currentAccount.is_admin)">
									<i class="material-icons">timeline</i>
									<translate>Statistic</translate>
								</el-menu-item>
							</router-link>
							<router-link :to="{ name: 'log', query: { type: 'loginLogs' } }" v-show="[1, 2, 4].includes(currentAccount.is_admin)">
								<el-menu-item index="3-2" data-router='{"/system/log": "3-2"}'>
									<i class="material-icons">chrome_reader_mode</i>
									<translate>System Log</translate>
								</el-menu-item>
							</router-link>
							<router-link :to="{ name: 'alarmNotify' }">
								<el-menu-item index="3-3" data-router='{"/system/alarmNotify": "3-3"}'>
									<i class="material-icons">announcement</i>
									<translate>Alarm Notify</translate>
								</el-menu-item>
							</router-link>
						</el-menu-item-group>
					</el-submenu>
					<el-submenu index="4">
						<template slot="title">
							<translate>Personal</translate>
						</template>
						<el-menu-item-group>
							<router-link to="/personal/info">
								<el-menu-item index="4-1" data-router='{"/personal/info": "4-1"}'>
									<i class="material-icons">account_circle</i>
									<translate>Account Info</translate>
								</el-menu-item>
							</router-link>
							<router-link to="/personal/security">
								<el-menu-item index="4-2" data-router='{"/personal/security": "4-2"}'>
									<i class="material-icons">security</i>
									<translate>Account Security</translate>
								</el-menu-item>
							</router-link>
							<router-link to="/personal/sshkey">
								<el-menu-item index="4-3" data-router='{"/personal/sshkey": "4-3"}'>
									<i class="material-icons">lock</i>
									<span>SSH KEY</span>
								</el-menu-item>
							</router-link>
						</el-menu-item-group>
					</el-submenu>
				</el-menu>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import $ from 'jquery'
import STORE_CONST from '../store/consts'
import { Utils } from '../config'
import Utility from '../Utils'
export default {
	name: 'LeftNav',
	data() {
		return {
			activeIndex: '',
			isCollapse: false,
			isUpdateAgent: false,
			newAgentVersion: '',
		}
	},
	mounted() {
		window.addEventListener('resize', function () {
			let result = window.matchMedia('(max-width: 700px)')
			if (result.matches) {
				this.isCollapse = true
			} else {
				this.isCollapse = false
			}
			console.log(this.isCollapse)
		})
		this.initDefaultMenu(this.$route.path)
		if (this.currentAccount.is_admin) {
			this.getNewAgentVersion()
		}

		console.log(this.currentAccount.is_admin, 'this.currentAccount.is_admin🌹🌹🌹🌹')
	},
	computed: {
		currentAccount() {
			return this.$store.getters.account
		},
		openedsIndex() {
			if (!sessionStorage.getItem('activeIndex')) {
				return ['1']
			} else {
				return sessionStorage.getItem('activeIndex').split('-').splice(0, 1)
			}
		},
	},
	methods: {
		initDefaultMenu(path) {
			const menus = $('.el-menu-item')
			Object.forEach(menus, (item, index) => {
				if ($(item).data('router')) {
					const routerConfig = $(item).data('router')
					for (const key in routerConfig) {
						if (path.split('/').length === 4) {
							//                console.log('lenght4', path.split('/').length)
							let route = path.split('/').splice(0, 3)
							if (route.join('/').indexOf(key) >= 0) {
								this.activeIndex = $(item).data('router')[key]
								sessionStorage.setItem('activeIndex', this.activeIndex)
							}
						} else {
							if (path === key) {
								this.activeIndex = $(item).data('router')[key]
								sessionStorage.setItem('activeIndex', this.activeIndex)
							}
						}
					}
				}
			})
			if (!this.activeIndex) {
				this.activeIndex = sessionStorage.getItem('activeIndex') || '1-1'
			}
		},
		// 获取最新的agent版本
		getNewAgentVersion() {
			this.$store.dispatch(STORE_CONST.CLUSTER.CHECK_AGENT).then((res) => {
				this.newAgentVersion = res.version
				this.getClusterList()
			})
		},
		// 获取集群列表
		getClusterList() {
			let params = {
				params: {
					page_size: Utils.config.maxPageSize,
				},
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_CLUSTER, params).then((res) => {
				console.log(res)
				let agentList = []
				res.objects.map((item) => {
					if (item.agent_version) {
						agentList.push(item)
					}
				})
				console.log(agentList)
				agentList.forEach((item) => {
					if (Utility.Utils.isNeedUpdate(item.agent_version, this.newAgentVersion) && !item.parent_id) {
						this.isUpdateAgent = true
					}
				})
			})
		},
	},
	watch: {
		$route(to, from) {
			this.initDefaultMenu(this.$route.path)
		},
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
.csos-logo {
	margin: 15px 20px;
	line-height: 30px;
}

.logo {
	padding: 20px 0 10px;
	width: 157px;
}

.el-menu {
	// background-color: #fafafa;
	background-color: #262a3a;
	color: #fff;
	.el-menu-item {
		// color: black;
		color: white;
		padding-left: 20px;
		height: 40px;
		line-height: 40px;
		&:hover {
			// background-color: #ccc;
			background-color: #3f85ff;
		}
		&.is-active {
			// background-color: #f60;
			// color: white;
			background-color: #20a0ff;
		}
		i {
			font-size: 18px;
			position: relative;
			top: 4px;
			margin-right: 5px;
		}
	}
}

.el-submenu {
	.el-menu {
		// background-color: #f8f8f8;
		background-color: #292c3f;
		.el-menu-item:hover {
			// background-color: #eee;
			background-color: #363a4b;
		}
		.is-active:hover {
			// background-color: #f60;
			background-color: rgb(32, 160, 255);
		}
	}
	.el-submenu__title {
		// color: #000;
		color: white;
		height: 40px;
		line-height: 40px;
		&:hover {
			// background-color: #eee;
			background-color: #3f85ff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// left-nav.vue?86658e4a